module.exports = __webpack_public_path__ + "static/media/paidy-bw@3x.fe87a03d.png";